// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1579618889414
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/Landing/Landing.scss
// module id = ./src/components/Landing/Landing.scss
// module chunks = 0